import { ContactInfo } from '@app/+about/shared/types/contact-info.type';
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';
import { AccordionData } from '@app/shared/types/accordion-data.type';

// tabs data
export const contactTabs: ISectionTab[] = [
  {
    tabTitle: 'aboutUs',
  },
  {
    tabTitle: 'FAQ',
  },
];

// contact info
export const contactInfoData: ContactInfo[] = [
  {
    title: 'aboutUs.contactData.addressTitle',
    icon: 'map-1',
    description: 'aboutUs.contactData.addressValue',
  },
  {
    title: 'aboutUs.contactData.phoneNumber',
    icon: 'phone',
    description: '02191093981',
  },
  {
    title: 'aboutUs.contactData.whatsAppNumber',
    icon: 'phone',
    description: '09932485989',
  },
  // {
  //   title: 'aboutUs.contactData.fax',
  //   icon: 'phone',
  //   description: '09140761953',
  // },
  {
    title: 'aboutUs.contactData.email',
    icon: 'mail',
    description: 'info@wejoiner.com',
    descriptionClasses: '!lowercase',
  },
];

// contact faq
export const contactFAQ: AccordionData[] = [
  {
    _id: '0',
    question: 'aboutUs.faqData.item1.question',
    answer: 'aboutUs.faqData.item1.answer',
  },
  {
    _id: '1',
    question: 'aboutUs.faqData.item2.question',
    answer: 'aboutUs.faqData.item2.answer',
  },
  {
    _id: '2',
    question: 'aboutUs.faqData.item3.question',
    answer: 'aboutUs.faqData.item3.answer',
  },
  {
    _id: '3',
    question: 'aboutUs.faqData.item4.question',
    answer: 'aboutUs.faqData.item4.answer',
  },
  {
    _id: '4',
    question: 'aboutUs.faqData.item5.question',
    answer: 'aboutUs.faqData.item5.answer',
  },
  {
    _id: '5',
    question: 'aboutUs.faqData.item6.question',
    answer: 'aboutUs.faqData.item6.answer',
  },
];
